// extracted by mini-css-extract-plugin
module.exports = {"header":"Header-module--header--2gV_n","name":"Header-module--name--3foyz","title":"Header-module--title--3JWMg"};